import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { AbstractNodeView } from "@/components/editor/nodeviews/AbstractNodeView";

export const AbstractBlock = Node.create({
  name: "abstractBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      title: { default: "Abstract" },
      text: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="abstract-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "abstract-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AbstractNodeView);
  },
});
